module.exports = "<div class=\"container\">\n  <h1>Look up a venue anywhere in the world...</h1>\n  <div class=\"form-group\">\n    <input placeholder=\"Search\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"off\" type=\"text\" class=\"form-control map-search\" #autocomplete [formControl]=\"searchControl\">\n \n  </div>\n<div>\n \n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/find-location-anywhere/find-location-anywhere.component.html
// module id = ./src/app/find-location-anywhere/find-location-anywhere.component.html
// module chunks = main